import * as React from 'react';
import { Form, Table } from '../../components';
import BaseValidate from './base-validate.component';
import BaseCreate from './base-create.component';
import ApiService from '../../services/api.service';
import AppService, { alerttype } from '../../services/app.service';

interface IProps { 
  history?: any;
  id?: any;
  caption?: string;
  captionColor?: any;
  captionThin?: boolean;
  endPoint?: string;
  model: any;
  dataset?: Array<any>;
  defaultValue?: (data: any) => any;
  onError?: (data: any) => void;
  onSave?: (data: any) => void;
  validations?: any;
  page?: number;
  pageSize?: number;
  searchField?: string;
  cardColor?: any;
  cardGradientColor?: any;
  disableBackButton?: boolean;
  disableCard?: boolean;
  disableUploadButton?: boolean;
  children?: React.ReactNode;
}

interface IState {
  datasetFromFile: any;
  datasetAll: Array<any>;
  dataset: Array<any>;
  datarow: any,
  header: Array<any>;
  page: number;
  pageSize: number;
  pageCount: number;
  pageName: string;
  actions: any;
  saveOrder: number;
  searchText: string;
  isSearch: boolean;
  isValidateError: boolean;
  isReady: boolean;
  isError: boolean;
}

export default class BaseUpload extends React.Component<IProps, IState> {
  
  constructor(props: IProps) {
    super(props);
    this.state = {
      datasetFromFile: this.props.dataset,
      datasetAll: [],
      dataset: [],
      datarow: null,
      header: this.props.model.columnUpload ||  this.props.model.columns,
      page: this.props.page || 1,
      pageSize: this.props.pageSize || 10,
      pageCount: 0,
      pageName: this.props.model.url.replace('/','') + (this.props.id || '') + 'Page',
      actions: [{id: 'upload', caption: 'Upload'}],
      saveOrder: -1,
      searchText: '',
      isSearch: this.props.model.columns?.findIndex((d: { name: string; }) => d.name === (this.props.searchField || 'name'))===1,
      isValidateError: false,
      isReady: false,
      isError: false,
    }
    
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeSearch = this.onChangeSearch.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    this.onClickUpload = this.onClickUpload.bind(this);
  }
  
  private historyState: any = this.props.history?.location.state;
  private isLoading: boolean = false;

  private loadDataFromFile (data: any) {
    var isValidateError: boolean = false;
    var dataset = new Array<typeof this.props.model>();
    
    (data || []).forEach((d: any, i: number) => {
      dataset.push({...this.props.model.defaultValue(), ...this.props.defaultValue? this.props.defaultValue(d) : d}); 
      const validateError = BaseValidate.validate(dataset[i], this.props.validations || this.props.model.validations);
      if (validateError) {
        dataset[i]['validate'] = Object.values(validateError).join(',<br/>').toString();
        isValidateError = true;
      }
    });
    this.setState({ datasetAll: dataset, isValidateError: isValidateError });
    return dataset;
  }

  private loadData (data: any, page: number, searchText?: string) {
    if (this.isLoading) return;
    this.isLoading = true;
    this.setState({ isReady: false});
    
    var dataset = new Array<typeof this.props.model>();
    const pageCount = Math.ceil((data.length || 1) / this.state.pageSize);    
    (data || []).slice((page - 1) * this.state.pageSize, page * this.state.pageSize).forEach((datarow: any, i: number) => {
      dataset.push(datarow); 
    });
    
    this.setState({ dataset: dataset, pageCount: pageCount, isReady: true });
    this.isLoading = false;
  }

  private table(){
    return (
      <Table header={this.state.header} dataset={this.state.dataset} page={this.state.page} pageCount={this.state.pageCount} actions={this.props.disableUploadButton? null : this.state.actions} searchText={this.state.searchText} isValidateError={this.state.isValidateError} isSearch={this.state.isSearch} isLoading={this.isLoading} isReady={this.state.isReady} isError={this.state.isError} onLoad={this.onLoadAll} onChangePage={this.onChangePage} onChangeSearch={this.onChangeSearch} onClickSearch={this.onClickSearch} onClickUpload={this.onClickUpload} readOnly >
        {this.props.children}
      </Table>
    );
  }
  
  private onLoadAll = (data: any) => {
    this.setState({ datasetFromFile: data})
    data = this.loadDataFromFile(data);
    this.loadData(data, this.state.page);
  }

  private onError = async(data: any) => {
    if (data) {
      this.state.datasetAll[this.state.saveOrder]['validate'] = {data: data?.[0], error: true}
      var saveOrder = this.state.saveOrder + 1;
      if (saveOrder >= this.state.datasetAll.length) saveOrder = -1;
      await this.setState({saveOrder: saveOrder});
      await this.props.onError?.(data);
    }
  }

  private onClickUpload() { 
    this.setState({saveOrder: 0});
  }

  private onChangePage (value: number) {
    AppService.historyState(this.state.pageName, value);
    this.setState({page: value});
    this.loadData(this.state.datasetAll, value, this.state.searchText);
  }
  
  private onChangeSearch(fieldName: string, value?: string) { 
    this.setState({searchText: value || ''});
    this.loadData(this.state.datasetAll, this.state.page, value);
  }
  
  private onClickSearch() { 
    this.loadData(this.state.datasetAll, this.state.page, this.state.searchText);
  }

  private onSave = async(data: any) => {
    const saveData = {...this.state.datasetFromFile?.[this.state.saveOrder], ...data}
    await this.props.onSave?.(saveData);
    this.state.datasetAll[this.state.saveOrder]['validate'] = {data: 'successful', error: false}
    var saveOrder = this.state.saveOrder + 1;
    if (saveOrder >= this.state.datasetAll.length) saveOrder = -1;
    await this.setState({saveOrder: saveOrder});
  }
  
  public static uploadFile = async(refid: number, data: any) => {
    var result = {alert: '', alertType: 'default' as alerttype}
    if (data.datarow.id > 0)
        await ApiService.delete(data.endPointDelete, data.datarow.id)
        .then(rp =>  {
          if (rp.Status) result = {alert: 'Media deleted.', alertType: 'success'}
          else  result = {alert: rp.Messages, alertType: 'error'}
        });
    
    if (data.datarow.files) {
        var formData = new FormData();

        formData.append('files', data.datarow.files);
        formData.append('fileInfo', JSON.stringify(data.datarow.files.fileInfo || {}));
        formData.append('ref', data.datarow.ref);
        formData.append('field', data.datarow.field);
        formData.append('refId', refid.toString());
        
        await ApiService.create(data.endPoint, formData)
        .then(rp => {
          if (rp.Status) result = {[data.datarow.field]: {data: rp.Data}, alert: 'Media uploaded.', alertType: 'success'}
          else  result = {alert: rp.Messages, alertType: 'error'}
        });
    }

    return result;
  }

  public componentDidMount() {
    const data = this.loadDataFromFile(this.state.datasetFromFile)
    const page = this.historyState?.[this.state.pageName] || this.state.page;
    this.loadData(data, page);
    this.setState({page: page})
  }

  public componentDidUpdate() {
    if (this.props.page && (this.props.page !== this.state.page)) {
      this.setState({page: this.props.page})
      this.loadData(this.state.datasetAll, this.props.page, this.state.searchText);
    }
  }
  
  public render(): React.ReactNode { 
    const datarow = this.state.datasetAll?.[this.state.saveOrder];
    
    return (
      <Form history={this.props.history} caption={this.props.caption || 'Upload ' + this.props.model.caption} captionColor={this.props.captionColor} captionThin={this.props.captionThin} buttonCaption=' ' cardColor={this.props.cardColor} cardGradientColor={this.props.cardGradientColor} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}>              
        {this.table()}
        <BaseCreate caption=' ' buttonCaption=' '
          endPoint={this.props.endPoint} model={this.props.model} datarow={datarow} onError={this.onError} onSave={this.onSave} save={!!datarow} disableAutoBack disableBackButton />
      </Form> 
    );
  }
}
